import React from 'react';

const CustomMarker = () => {
  const markerStyle = {
    position: 'absolute',
    transform: 'translate(-50%, -100%)',
  };

  return (
    <div style={markerStyle}>
      <img src="https://maps.google.com/mapfiles/ms/icons/red-dot.png" alt="Marker" />
    </div>
  );
};

export default CustomMarker;